import React, {useRef} from "react";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import RavenFormikField from "components/Common/RavenFormikField";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { getInitValue, getInitValueArray, displayNone, getInitValueBoolean } from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";
import { Form, Formik } from "formik";
import { RavenAgTable } from "components/Common/CombinedComponents";
let reflectToMerchant = false;
const blockedWithCommission = 1;
const commissionTable = [
  { name: "T+1", valueDateDayCount: "1", payOutTypeGuid: 3 },
  { name: "T+2", valueDateDayCount: "2", payOutTypeGuid: 1 },
  { name: "T+3", valueDateDayCount: "3", payOutTypeGuid: 1 },
  { name: "T+4", valueDateDayCount: "4", payOutTypeGuid: 1 },
  { name: "T+5", valueDateDayCount: "5", payOutTypeGuid: 1 },
  { name: "T+6", valueDateDayCount: "6", payOutTypeGuid: 1 },
  { name: "T+7", valueDateDayCount: "7", payOutTypeGuid: 1 },
  { name: "T+8", valueDateDayCount: "8", payOutTypeGuid: 1 },
  { name: "T+9", valueDateDayCount: "9", payOutTypeGuid: 1 },
  { name: "T+10", valueDateDayCount: "10", payOutTypeGuid: 1 },
  { name: "T+11", valueDateDayCount: "11", payOutTypeGuid: 1 },
  { name: "T+12", valueDateDayCount: "12", payOutTypeGuid: 1 },
  { name: "T+13", valueDateDayCount: "13", payOutTypeGuid: 1 },
  { name: "T+14", valueDateDayCount: "14", payOutTypeGuid: 1 },
  { name: "T+15", valueDateDayCount: "15", payOutTypeGuid: 1 },
  { name: "T+16", valueDateDayCount: "16", payOutTypeGuid: 1 },
  { name: "T+17", valueDateDayCount: "17", payOutTypeGuid: 1 },
  { name: "T+18", valueDateDayCount: "18", payOutTypeGuid: 1 },
  { name: "T+19", valueDateDayCount: "19", payOutTypeGuid: 1 },
  { name: "T+20", valueDateDayCount: "20", payOutTypeGuid: 1 },
  { name: "T+21", valueDateDayCount: "21", payOutTypeGuid: 1 },
  { name: "T+22", valueDateDayCount: "22", payOutTypeGuid: 1 },
  { name: "T+23", valueDateDayCount: "23", payOutTypeGuid: 1 },
  { name: "T+24", valueDateDayCount: "24", payOutTypeGuid: 1 },
  { name: "T+25", valueDateDayCount: "25", payOutTypeGuid: 1 },
  { name: "T+26", valueDateDayCount: "26", payOutTypeGuid: 1 },
  { name: "T+27", valueDateDayCount: "27", payOutTypeGuid: 1 },
  { name: "T+28", valueDateDayCount: "28", payOutTypeGuid: 1 },

];
export const MerchantCommissionForm = ({
  isOpen,
  isEdit,
  isDetail,
  record,
  className,
  formOnSubmitMiddleware,
  toggle,
  childToParentProps,
  formSubmitButtonRef,
  newData,
  agModalColumns,
  recordBankList,
  t,
  cellEditValidation,
  handleRadioButton,
  radioButtonValue,
}) => {
  const formRef = useRef(null);

  return (
    <Modal
      isOpen={isOpen}
      className={className}
      size="xl"
      backdrop="static"
      id="staticBackdrop"
    >
      <ModalHeader toggle={toggle} tag="h4">
        {
        t(t("merchantCommissionListDetail")
        )}
      </ModalHeader>
      <ModalBody>
        <Formik
          enableReinitialize={true}
          initialValues={{
            guid: getInitValue(record, record.merchantCommissionGuid == 0 ? record.payFacCommissionGuid: record.merchantCommissionGuid ),
            payFacGuid: "231212070916144554",
            bankGuid: getInitValue(record, record.bankGuid),
            payFacCommissionGuid: getInitValue(record, record.payFacCommissionGuid),
            payOutTypeGuid: getInitValue(record,record.payOutTypeGuid),
            valueDateDayCount: getInitValue(record, record.valueDateDayCount),
            status: getInitValueBoolean(record, record.status),
            merchantCommissionInstallmentDefs: getInitValueArray(newData, newData)
          }}
          validationSchema={Yup.object().shape({
            valueDateDayCount: Yup.number()
              .when('payOutTypeGuid', {
                is: (payOutTypeGuid) => payOutTypeGuid === blockedWithCommission,
                then: () => Yup.number().required(t("mustBe"))
                  .typeError(t("invFormat")),
                otherwise: () => Yup.number().notRequired().default(0)
              }),
            // payOutTypeGuid: Yup.number().required(t("mustBe")),

          })
          }
          onSubmit={formOnSubmitMiddleware}
          innerRef={formRef}
        >
          {({ errors, status, touched, setFieldValue, values }) => (
            <Form>
              <Row>
                <Col lg={6} className="col-4">
                  <RavenFormikField
                    errors={errors}
                    touched={touched}
                    name={"bankGuid"}
                    label={"bankName"}
                    component="multiselect"
                    type="singleselect"
                    isMulti={false}
                    valueList={recordBankList}
                    nameOnValueList={["bankName"]}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={12} className="col-6">
                  <Col lg={4} className="col-4">
                    <RavenFormikField
                      errors={errors}
                      touched={touched}
                      name={"reflectToMerchant"}
                      label={"reflectToMerchant"}
                      component="radiobutton"
                      checked={radioButtonValue}
                      onChange={e => {
                        handleRadioButton(e,values);
                      }}
                      disabled={false}
                    />
                  </Col>
                </Col>
              </Row>
              <RavenAgTable
                exportOption={false}
                recordcolumns={agModalColumns}
                recordList={newData}
                paginationPageSize={20}
                tableRecordProps={data => childToParentProps(data, newData)}
                cellEditValidation={data => cellEditValidation(data)}
              />

              <Row>
                <Col lg={3} className="mb-11"></Col>
                <Col lg={9} className="pt-2">
                  <div className="container text-end  ">
                    <button ref={formSubmitButtonRef} type="submit" hidden />
                    <button
                      ref={formSubmitButtonRef}
                      type="submit"
                      className="btn btn-success save-event "
                      style={{ marginRight: "3px" }}
                    >
                      {t("save")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary save-customer "
                      onClick={toggle}
                    >
                      {t("cancel")}
                    </button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal >
  );
};

MerchantCommissionForm.propTypes = {
  isOpen: PropTypes.any,
  isEdit: PropTypes.any,
  isDetail: PropTypes.any,
  record: PropTypes.any,
  className: PropTypes.any,
  formOnSubmitMiddleware: PropTypes.any,
  toggle: PropTypes.any,
  form: PropTypes.any,
  childToParentProps: PropTypes.any,
  formSubmitButtonRef: PropTypes.any,
  valueList: PropTypes.any,
  newData: PropTypes.any,
  agModalColumns: PropTypes.any,
  recordBankList: PropTypes.any,
  t: PropTypes.any,
  cellEditValidation: PropTypes.func,
  handleRadioButton: PropTypes.func,
  radioButtonValue: PropTypes.any,
};
